export default "__VITE_ASSET__37156f9e__"